import { Component } from '@angular/core'
import { FormControl } from '@angular/forms'
import {
  FormInputComponent,
  SharedModule,
  IntCustomFieldConfig,
} from '@vendure/admin-ui/core'

@Component({
  selector: 'bundle-list-price-input',
  template: '',
  standalone: true,
  imports: [SharedModule],
})
export class BundleListPriceInputComponent
  implements FormInputComponent<IntCustomFieldConfig>
{
  readonly: boolean
  formControl: FormControl<any>
  config: IntCustomFieldConfig
}

